import $ from 'jquery';

$(function () {
    const $docEl = $('html, body');
    let bodyScrollTop = 0;

    $.lockBody = function () {
        if (window.pageYOffset) {
            bodyScrollTop = window.pageYOffset;
        }
        setTimeout(function () {
            $docEl.css({
                height: '100%',
                overflow: 'hidden'
            });
        }, 260);
    };

    $.unlockBody = function () {
        $docEl.css({
            height: '',
            overflow: ''
        });

        window.scrollTo({
            left: 0,
            top: bodyScrollTop,
            behavior: 'instant'
        });
        window.setTimeout(function () {
            bodyScrollTop = null;
        }, 0);
    };

    document.querySelector('#navbar').addEventListener('shown.bs.collapse', function () {
        $.lockBody();
    });

    document.querySelector('#navbar').addEventListener('hide.bs.collapse', function () {
        $.unlockBody();
    });

    $(
        '.mainmenu > .menu-item-type-custom > .nav-link, .mainmenu .menu-item-type-custom > .dropdown-item'
    ).on('click', function (event) {
        if ($(this).next('.dropdown-toggle').length > 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
            $(this).next('.dropdown-toggle').dropdown('toggle');
        }
    });

    $(window).on('resize', function () {
        if ($(window).width() > 1200 && $('.navbar-collapse').hasClass('show')) {
            $.unlockBody();
        } else if ($(window).width() < 1200 && $('.navbar-collapse').hasClass('show')) {
            $.lockBody();
        }
    });
});
